var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticStyle: { height: "100%" } },
    [
      _c(
        "v-layout",
        { staticStyle: { "flex-direction": "column", height: "100%" } },
        [
          _c("ExecutionResultsDialog", { ref: "executionResultsDialog" }),
          _vm._v(" "),
          _c("ResultsHeader", {
            attrs: { viewer: _vm.$refs.viewer },
            on: {
              refresh: function ($event) {
                return _vm.loadResults()
              },
            },
          }),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticStyle: { "flex-grow": "1" } },
            [
              _c(
                "v-layout",
                { staticStyle: { height: "100%" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: { position: "relative" },
                      attrs: { md8: "", lg8: "" },
                    },
                    [
                      _c("PlaceholderView"),
                      _vm._v(" "),
                      _c(_vm.currentView, {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !_vm.states.loadingResults &&
                              !_vm.states.errorResults,
                            expression:
                              "!states.loadingResults && !states.errorResults",
                          },
                        ],
                        ref: "viewer",
                        tag: "component",
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "divider-left",
                      attrs: { md4: "", lg4: "" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticStyle: { height: "100%" },
                          attrs: { color: "#fafafa", flat: "" },
                        },
                        [
                          _c("ButtonCounts", { staticClass: "pb-1" }),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-tabs",
                            {
                              attrs: {
                                dense: "",
                                mandatory: "",
                                centered: "",
                                grow: "",
                                "icons-and-text": "",
                                color: "transparent",
                                "slider-color": "success",
                                "active-class": "success--text text--darken-1",
                              },
                              model: {
                                value: _vm.stepper,
                                callback: function ($$v) {
                                  _vm.stepper = $$v
                                },
                                expression: "stepper",
                              },
                            },
                            [
                              _c(
                                "v-tab",
                                {
                                  attrs: {
                                    href: `#${_vm.STEPPERS.review}`,
                                    ripple: "",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "text-none" }, [
                                    _vm._v("Submission Logs"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        large: "",
                                        color:
                                          _vm.stepper == _vm.STEPPERS.review
                                            ? "success"
                                            : "",
                                      },
                                    },
                                    [_vm._v("pending_actions")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _vm.isTenantAdmin
                                ? _c(
                                    "v-tab",
                                    {
                                      attrs: {
                                        href: `#${_vm.STEPPERS.resubmit}`,
                                        ripple: "",
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "text-none" }, [
                                        _vm._v("Current Changes"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            large: "",
                                            color:
                                              _vm.stepper ==
                                              _vm.STEPPERS.resubmit
                                                ? "success"
                                                : "",
                                          },
                                        },
                                        [_vm._v("history")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-tabs-items",
                            {
                              model: {
                                value: _vm.stepper,
                                callback: function ($$v) {
                                  _vm.stepper = $$v
                                },
                                expression: "stepper",
                              },
                            },
                            [
                              _c(
                                "v-tab-item",
                                { attrs: { value: _vm.STEPPERS.review } },
                                [
                                  _vm.stepper == _vm.STEPPERS.review
                                    ? _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "fill-height": "",
                                            column: "",
                                          },
                                        },
                                        [_c("Review", { ref: "review" })],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tab-item",
                                { attrs: { value: _vm.STEPPERS.resubmit } },
                                [
                                  _vm.stepper == _vm.STEPPERS.resubmit
                                    ? _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "fill-height": "",
                                            column: "",
                                          },
                                        },
                                        [_c("Changes")],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }